import React from 'react';
import { useTranslation } from 'react-i18next';
import * as types from '../../types';
import { useCartCheckout } from '../CartSummary/CartActions';
import useHardwareFirstTotals from './useHardwareFirstTotals';
import styles from './HardwareFirstCheckoutBar.module.scss';

interface HardwareFirstCheckoutBarProps {
  id?: string;
  onCheckOut: (checkoutCart: types.Cart, cartPricing: types.CartPricing) => void;
}

/** The pinned bar carrying the pre-tax subtotal and the page's only route into checkout. */
export default function HardwareFirstCheckoutBar({ id, onCheckOut }: HardwareFirstCheckoutBarProps) {
  const { t } = useTranslation();
  const { hardwareInCents, discountInCents, totalInCents, formatPrice } = useHardwareFirstTotals();
  const checkout = useCartCheckout(onCheckOut);

  return (
    <div className={styles.bar} id={id}>
      <div className={styles.priceRow}>
        <span className={styles.dueToday}>{t('subtotal')}</span>
        <span className={styles.price}>
          {discountInCents > 0 && (
            <span className={styles.pill}>
              {t('hardware_first_amount_off', { amount: formatPrice(discountInCents) })}
            </span>
          )}
          <span className={styles.total}>{formatPrice(totalInCents)}</span>
          {discountInCents > 0 && <span className={styles.listPrice}>{formatPrice(hardwareInCents)}</span>}
        </span>
      </div>
      <button className={styles.checkoutButton} onClick={checkout} type="button">
        {t('checkout')}
      </button>
    </div>
  );
}
